/*
 * COPYRIGHT 2023 Jobvite, Inc. All rights reserved. This copyright notice is Copyright Management
 * Information under 17 USC 1202 and is included to protect this work and deter copyright
 * infringement. Removal or alteration of this Copyright Management Information without the express
 * written permission of Jobvite, Inc. is prohibited, and any such unauthorized removal or
 * alteration will be a violation of federal law.
 */

import React, { FC } from 'react';
import { useMultipleLocalizedText } from '../../../../contexts/Localization/localizationHooks';
import { Breadcrumb, BreadcrumbItem, Paper } from '@pixel/core';

interface ModalBreadcrumbProps {
    DimensionHierarchyTree: any;
    onBreadcrumChange: any;
    searchText: string;
}

export const AddDimensionModalBreadcrumb: FC<ModalBreadcrumbProps> = ({ DimensionHierarchyTree, searchText, onBreadcrumChange }) => {

    const {
        ODS_ALL
    } = useMultipleLocalizedText()

    return (
        <Paper elevation={2} sx={{ p: 3, mb: 3 }} className='modal-breadcrumb'>
            {
                (searchText.length <= 1 && <Breadcrumb variant="primaryLink" className='ods-breadcrumb bu-breadcrumb' maxItems={5} itemsBeforeCollapse={2} itemsAfterCollapse={2}>
                    {DimensionHierarchyTree.map((dimension: { name: string; }, i: React.Key) => (i === DimensionHierarchyTree.length - 1) ? (
                        <BreadcrumbItem key={i} label={dimension?.name} className={'bu-breadcrumb-link' + i} />
                    ) : (<BreadcrumbItem key={i} label={dimension?.name} className={'bu-breadcrumb-link' + i} onClick={() => onBreadcrumChange(dimension)} />))}
                </Breadcrumb>)
            }
            {
                (searchText.length > 1 && <Breadcrumb variant="primaryLink" className='ods-breadcrumb bu-breadcrumb'>
                    <BreadcrumbItem label={ODS_ALL || 'ALL'} className='bu-breadcrumb-all' onClick={() => { onBreadcrumChange({ name: ODS_ALL || 'ALL', eid: '' }); }} />
                    <BreadcrumbItem label={`Search Results for: "${searchText || ''}"`} maxLength={60} className='bu-breadcrumb-search-all' />
                </Breadcrumb>)
            }
        </Paper>
    );
}